import { useState } from "react";
import { ComboBoxItem } from "@/utils/helper.util";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HiOutlineArrowSmallRight } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import NumericBadge from "@/components/atoms/NumericBadge";
import Modal from "@/components/molecules/Modal";
import IndustryAllModal from "@/components/organisms/filter/industry/IndustryAllModal";

type Props = {
  formName: string;
};

const IndustryAllHandler = ({ formName }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const values: ComboBoxItem[] = useWatch({ name: formName }) || [];

  return (
    <>
      <div className={"flex items-center justify-between"}>
        <Button
          onClick={() => setIsOpen(true)}
          trailingIcon={<HiOutlineArrowSmallRight className={"size-4 stroke-2"} />}
          label={t("search.filter.industry.advanced.seeAll")}
          size={"2xs"}
          variants={"text"}
          className={"mt-0.5 !pl-0"}
        />

        <NumericBadge value={values.length} color={"blue"} />
      </div>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size={"lg"}
        content={IndustryAllModal}
        contentProps={{
          formName,
          onSuccess: () => setIsOpen(false),
        }}
      />
    </>
  );
};

export default IndustryAllHandler;
